import {Injectable} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../environments/environment";

@Injectable({providedIn: "root"})
export class LocaleService {

	private locale: string;
	private readonly CLIENT_COUNTRY_KEY: string = 'client-country';

	constructor(private translateService: TranslateService) {
	}

	initLocale() {
		this.locale = this.resolveLocale();
		this.translateService.setDefaultLang(this.locale);
		this.translateService.use(this.locale);
	}

	currentLocale(): string {
		if (this.locale == null) {
			this.locale = this.resolveLocale();
		}

		return this.locale;
	}

	clientLocale(): string {
		const supportedLocales: string[] = Object.keys(environment.applicationUrl);
		let clientCountry = localStorage.getItem(this.CLIENT_COUNTRY_KEY);
		if (clientCountry == 'null') {
			return this.resolveLocale();
		}
		return supportedLocales.find(locale => locale.endsWith(clientCountry));
	}

	getLocaleForCountry(countryCode: string): string {
		const supportedLocales: string[] = Object.keys(environment.applicationUrl);
		return supportedLocales.find(locale => locale.endsWith(countryCode));
	}

	setDefaultLocale(locale: string) {
		this.translateService.setDefaultLang(locale);
		this.translateService.use(locale);
		this.locale = locale;
	}

	public resolveLocale(): string {
		const supportedLocales: string[] = Object.keys(environment.applicationUrl);
		const locales: string[] = supportedLocales.filter(locale => {
			const currentUrl: string = window.location.href;
			return currentUrl.startsWith(environment.applicationUrl[locale]);
		});

		if (locales.length != 1) {
			console.info('Unable to resolve locale for ' + window.location.href + ". Default will be used: ", environment.defaultLocale);
			return environment.defaultLocale;
		}

		return locales[0];
	}
}
